<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { ParameterCardV2, SidepanelContent, Text } from '@Shelly/shelly-design-system';
	import DaisyEMTariffSettings from 'src/components/DevicesSettings/Settings/SettingsG2/DaisyEMTariffSettings.svelte';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: tariff = status?.[`em1:${device?.channel ?? 0}`]?.tariff;
	$: tariffLabel =
		tariff != null
			? `T${tariff}`
			: $format('not_available_short', { default: 'N/A' });
</script>

<SidepanelContent hideSlotStaticBottom>
	<div slot="staticTop" class="mb-m">
		<Text styleType="miniature" class="text-color-muted">
			{$format('label_active_tariff', { default: 'Active tariff' })}
		</Text>
		<ParameterCardV2
			title={tariffLabel}
			description={$format('label_active_tariff', { default: 'Active tariff' })}
			size="s"
			class="mt-xs"
		/>
	</div>

	<div class="flex-full-height justify-content-top">
		<DaisyEMTariffSettings {device} />
	</div>
</SidepanelContent>
